import { Button, ButtonLink, Stack } from '@fukuri-admins/ui/common';
import { TextInputFieldController } from '@fukuri-admins/ui/common/Form';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

type Props = {
  title: string;
  isSubmitDisabled: boolean;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

export const EditBranchFormPresentation: React.FC<Props> = ({
  title,
  isSubmitDisabled,
  onSubmit,
}) => (
  <form onSubmit={onSubmit} className={styles.form}>
    <Stack direction='column' gap={24}>
      <h2 className={styles.formTitle}>{title}</h2>
      <div className={styles.formContainer}>
        <Stack direction='column' gap={24}>
          <TextInputFieldController
            name='name'
            fieldWrapperProps={{
              labelText: '事業所名',
            }}
            textInput={{
              placeholder: '事業所名を入力してください',
            }}
          />
          <TextInputFieldController
            name='code'
            fieldWrapperProps={{
              labelText: '事業所コード',
              helperText: '英数字のみ使用可能。',
            }}
            textInput={{
              placeholder: '入力してください',
            }}
          />
        </Stack>
      </div>
      <Stack direction='row' gap={8}>
        <ButtonLink to={ROUTES.BRANCHES.INDEX} variant='secondary'>
          キャンセル
        </ButtonLink>
        <Button type='submit' disabled={isSubmitDisabled}>
          保存
        </Button>
      </Stack>
    </Stack>
  </form>
);
